import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import _ from "lodash";
import {LoadingBar} from "./Loader";
import Dropdown from "./Dropdown";
import {bindActionCreators} from "redux";
import {fetchTags, resetTags} from "../../creators/tags";


class AutocompletedTag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTag: "",
            indexTagList: 0,
            toggleTag : false,
            mouseInPerimeter: false
        };
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleAddTag = this.handleAddTag.bind(this);
        this.fetchTag = _.debounce(this.fetchTag, 300).bind(this);

        document.addEventListener("keydown", this.handleKeyPress);
        // this.fetchTag(this.state.searchTag);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
        this.setState({toggleTag: false, searchTag: ''});
        this.props.resetTags();
    }

    fetchTag(){
        let string = this.state.searchTag;
        string = string.replace(/[^a-zA-Z0-9 ]/g,'');
        this.props.fetchTags({search : string, limit : 5});
    }


    handleAddTag(event) {
        this.setState({searchTag: event.target.value, toggleTag: true,mouseInPerimeter: true});
        this.fetchTag();
    }

    addTag(item) {
        this.props.addTag(item);
        this.setState({
            toggleTag: false,
            searchTag: '',
            indexTagList: 0,
            mouseInPerimeter: false
        });
    }

    handleIndexTag(index) {
        this.setState({indexTagList: index});
    }
    handleMouseEnter(index) {
        this.setState({mouseInPerimeter: true, indexTagList: index});
    }

    handleMouseLeave(index) {
        this.setState({mouseInPerimeter: false, indexTagList: index});
    }

    handleKeyPress({key}) {
        if (key === "Enter" && this.state.toggleTag && (this.props.tags.length >= 1 || this.state.searchTag.length >= 1)) {
            let firstTag = this.props.tags;

            let selectFriend = firstTag[this.state.indexTagList] || {title : this.state.searchTag};
            if (selectFriend) {
                this.addTag(selectFriend);
            }

        }

        if (key === "ArrowDown" && this.state.toggleTag) {
            let tags = this.props.tags;
            let count = tags.length - 1;

            let index = this.state.indexTagList;
            index++;
            if (index > count) {
                index = 0;
            }
            this.handleIndexTag(index);
        }
        if (key === "ArrowUp" && this.state.toggleTag) {
            let tags = this.props.tags;
            let count = tags.length - 1;
            let index = this.state.indexTagList;
            index--;
            if (index < 0) {
                index = count;
            }
            this.handleIndexTag(index);
        }

        if (key === "Escape" && this.state.toggleTag) {
            this.setState({searchTag: "", toggleTag: false, indexTagList: 0, mouseInPerimeter : false});
        }
    }

    render() {
        return (
            <Fragment>
                <input type={"text"}
                       placeholder={"Ecrivez votre tag ici ..."}
                       maxLength="29"
                       className={this.props.className ? this.props.className : ""}
                       value={this.state.searchTag}
                       onChange={(event) => this.handleAddTag(event)}
                       onFocus={() => this.setState({toggleTag: true})}
                       onBlur={() => !this.state.mouseInPerimeter ? this.setState({toggleTag: false}) : ""}
                />
                <span
                    className={`row no-shrink max-characters mx-4 ${this.state.searchTag.length === 29 ? 'max-reached' : ''}`}>({this.state.searchTag.length} / 29 caractères)</span>
                {this.props.tagsInitialized && this.props.tagsLoading && (
                    <LoadingBar />
                )}
                <div className={"autocompleted-tags"}>
                    {this.state.searchTag.length >= 1 && (
                        <Dropdown className="tag-box" align="right toggle-friend"
                                  toggle={this.state.toggleTag}>
                            {this.props.tags.map((item, index) => {
                                if(this.props.tagBlackListIds){
                                    if(this.props.tagBlackListIds.includes(item._id.toString())){
                                        return null;
                                    }
                                }
                                return (
                                    <li
                                        key={index}
                                        onClick={() => this.addTag(item)}
                                        onMouseEnter={() => this.handleMouseEnter(index)}
                                        onMouseLeave={() => this.handleMouseLeave(index)}
                                        className={this.state.indexTagList === index ? 'tags active' : ''}
                                    >
                                        {item.title}
                                    </li>
                                )
                            })}
                        </Dropdown>
                    )}
                </div>
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetTags,
    fetchTags
}, dispatch);

const mapStateToProps = (state) => {
    return {
        tags: state.tags.data,
        tagsInitialized : state.tags.initialized,
        tagsLoading : state.tags.loading,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AutocompletedTag);
